import connectHost from 'atlassian-connect-js';
import '@atlassian/alljscdn/dist/combined';
import logger from '@atlassian/jira-common-util-logging/src/log';
import { getUserLocation } from '@atlassian/jira-platform-router-utils/src/common/utils/index.tsx';
import { getAnalyticsWebClientPromise } from '@atlassian/jira-product-analytics-web-client-async';
import { registerConnectStyles } from './core-jsapi-v5/css';
import { registerContextCache } from './core-jsapi-v5/js/context/main.tsx';
import { registerContentResolver } from './core-jsapi-v5/js/iframe/host/content-resolver.tsx';
import { registerDialogOptions } from './core-jsapi-v5/js/iframe/host/dialog-options.tsx';
import {
	registerAcCreate,
	registerAnalyticsHandler,
	registerIframeHandlers,
} from './core-jsapi-v5/js/iframe/host/main.tsx';
import { registerCoreModules } from './core-jsapi-v5/js/iframe/host/module-loader.tsx';
import { registerDashboardItemEvents } from './jira-connect-jsapi-v5/js/dashboard-item/index.tsx';
import { registerJiraModules } from './jira-connect-jsapi-v5/js/module-loader.tsx';
import { registerJiraRoutes } from './jira-connect-jsapi-v5/js/navigator/routes.tsx';
import { registerWorkflowEvents } from './jira-connect-jsapi-v5/js/workflow-post-function/index.tsx';
import { waitForLegacyConnectWRM } from './legacy-wrm';

// - `action="replaced": it means the legacy ACJS is loaded on the page first, then modern ACJS is replacing current old ACJS on the page.
// - `action="loaded": it means the modern ACJS is loaded on the first.
type LOADING_ACJS_ACTION = 'loaded' | 'replaced';

export const performSideEffects = async () => {
	const action: LOADING_ACJS_ACTION =
		// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
		window.connectHost != null && window.connectHost !== connectHost ? 'replaced' : 'loaded';
	getAnalyticsWebClientPromise().then((analyticsClient) => {
		analyticsClient.getInstance().sendOperationalEvent({
			source: 'connect-loader',
			actionSubject: 'connectHost',
			action,
			attributes: {
				// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
				isSpa: !!window.__SPA__,
				userLocation: getUserLocation(),
			},
		});
	});

	// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
	window.connectHost = connectHost;
	connectHost.__FLAVOUR__ = 'MODERN';

	const loadingTimeout = 5000;
	const loaderPromises = [
		waitForLegacyConnectWRM(loadingTimeout),

		registerDialogOptions(),
		registerAcCreate(),
		registerIframeHandlers(connectHost),
		registerAnalyticsHandler(),
		registerContentResolver(connectHost),
		registerContextCache(connectHost),
		registerCoreModules(connectHost),

		registerDashboardItemEvents(connectHost),
		registerJiraRoutes(),
		registerWorkflowEvents(connectHost),
		registerJiraModules(connectHost),

		registerConnectStyles(),
	];

	await Promise.all(loaderPromises).catch((error) => {
		logger.safeErrorWithoutCustomerData(
			'connect.loader',
			`Failed to fully load connectHost: ${error}`,
		);
	});
};
